<form 
    (ngSubmit)="$event.preventDefault(); saveConsideration();"
    [formGroup]="considerationForm"
    class="w-full h-full flex flex-col items-center justify-start gap-4 overflow-y-auto"
>
    <div class="w-full overflow-y-auto px-1">                    
        <h2 class="pb-2 w-full oswald-font text-xl font-medium text-start">
            Intervention and Monitoring Considerations
        </h2>
        <p class="font-semibold">
            For each item checked, please include specific information in the Record of Assigned Responsibilities (ROAR) portion regarding what steps will be taken, who is responsible, and the time frame for completion.
        </p>
        <div class="w-full flex flex-col items-center gap-2 pb-4"> 

            
            <div *ngFor="let item of checkList"class="w-full flex flex-col gap-2">
                <div class="w-full flex items-center">
                    <input [id]="item.formControlName" 
                    [formControlName]="item.formControlName"
                    type="checkbox"
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500focus:ring-2">
                    <label [for]="item.formControlName" class="ms-2 font-semibold">
                        {{ item.label }}
                    </label>
                </div>

                <div *ngIf="considerationForm.get(item.formControlName)?.value" class="pl-4 flex flex-col gap-2">

                    <div *ngIf="item.formControlName === 'increased_contact'" class="w-full flex flex-col items-start text-start">
                        <div class="w-full font-semibold">
                            <p>Type of check-in required: *</p>
                        </div>
                        <div class="w-full flex items-start gap-2">
                            <div>
                                <input type="radio" id="daily" value="Daily" class="hidden peer"
                                    formControlName="increased_contact_check_in"
                                >
                                <label for="daily"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Daily
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="weekly" value="Weekly" class="hidden peer"
                                    formControlName="increased_contact_check_in"
                                >
                                <label for="weekly"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Weekly
                                </label>
                            </div>
                            <div>
                                <input type="radio" id="other" value="Other" class="hidden peer"
                                    formControlName="increased_contact_check_in"
                                >
                                <label for="other"
                                class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                                    Other
                                </label>
                            </div>
                        </div>
                    </div>

                    <div 
                        *ngIf="item.formControlName !== 'increased_contact' || considerationForm.get('increased_contact_check_in')?.value === 'Other'" 
                        class="w-full flex flex-col items-start text-start"
                    >
                        <div class="w-full font-semibold">
                            <p>Planning Notes: *</p>
                        </div>
                        <div class="w-full flex flex-col items-center">
                            <textarea [formControlName]="item.notes"
                                        rows="3"
                                        class="block p-2 w-full text-sm text-gray-900 bg-gray-50 rounded border border-gray-300"
                                        placeholder="Type here..."></textarea>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-full flex flex-col items-start text-start">
                <div class="w-full font-semibold">
                    <p>Does this section require one or more assigned responsibilities to manage and support in the ROAR? *</p>
                </div>
                <div class="w-full flex items-start gap-2">
                    <div>
                        <input type="radio" id="intervention_roar_needed_yes" value="{{ yesNo.Yes }}" class="hidden peer"
                            formControlName="intervention_roar_needed"
                        >
                        <label for="intervention_roar_needed_yes"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium text-center hover:text-gray-900 bg-gray-50 border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            Yes
                        </label>
                    </div>
                    <div>
                        <input type="radio" id="intervention_roar_needed_no" value="{{ yesNo.No }}" class="hidden peer"
                            formControlName="intervention_roar_needed"
                        >
                        <label for="intervention_roar_needed_no"
                        class="inline-flex items-center justify-center w-full px-2 py-1 text-sm font-medium hover:text-gray-900 bg-gray-50  border rounded cursor-pointer text-gray-500 border-gray-300 peer-checked:border-blue-700 peer-checked:bg-blue-50 peer-checked:text-blue-700 hover:bg-gray-50">
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full flex flex-row gap-2 items-center justify-end">
            <button
                type="submit"
                class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                [ngClass]="{
                    'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': this.considerationForm.invalid,
                    'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': this.considerationForm.valid
                }"
                [disabled]="this.considerationForm.invalid"
            >
                Save
            </button>
        </div>
    </div>
</form>